import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="agency-assignment"
export default class extends Controller {
  static targets = [ "current", "editor" ]
  connect() {
  }

  change() {
    this.currentTarget.classList.add("hidden");
    this.editorTarget.classList.remove("hidden");

    const input = this.editorTarget.querySelector("input");
    if (input) { input.focus(); }
  }
}
